<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="slugify"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      :image="{
        type: 'jpeg',
        quality: 1,
      }"
      :html-to-pdf-options="pdfOptions"
      ref="html2Pdf"
      @progress="onProgress($event)"
      @hasDownloaded="hasDownloaded($event)"
    >
      <section slot="pdf-content">
        <section class="pdf-item" style="background-color: #f5f5f5">
          <div
            style="text-align: center; padding: 10px; background-color: #2471a3"
          >
            <h2 style="color: white">
              {{ $t("statistics.hAttendanceAnalysis") }}
            </h2>
          </div>
          <div style="margin-left: 10px">
            <strong>Filter parameters</strong>
            <table
              style="
                max-width: 100%;
                min-width: 98%;
                margin: 10px;
                text-align: left;
                border: 1px solid lightgray;
                padding-left: 10px;
              "
            >
              <tr>
                <th style="min-width: 100px; height: 20px; vertical-align: top">
                  {{ $t("search.startDate") }}
                </th>
                <td style="min-width: 20px; text-align: center">:</td>
                <td></td>
                <td>
                  <h4>{{ sessionStatisticsInputs.start_date }}</h4>
                </td>
              </tr>
              <tr>
                <th style="min-width: 100px; height: 20px; vertical-align: top">
                  {{ $t("search.endDate") }}
                </th>
                <td style="min-width: 20px; text-align: center">:</td>
                <td></td>
                <td>
                  <h4>{{ sessionStatisticsInputs.end_date }}</h4>
                </td>
              </tr>
              <tr>
                <th>{{ $t("agenda.lblMeetingType") }}</th>
                <td style="text-align: center">:</td>
                <td></td>
                <td>
                  {{ meetingTypeObj.label }}
                </td>
              </tr>
              <tr>
                <th>{{ $t("admin.users") }}</th>
                <td style="text-align: center">:</td>
                <td></td>
                <td>
                  <v-chip
                    small
                    class="pl-0 pr-1 mr-1 mt-1"
                    style="
                      padding-left: 0px;
                      padding-right: 10px;
                      margin-right: 5px;
                      margin-top: 5px;
                    "
                    v-for="(item, index) in filteredUsers"
                    :key="index"
                  >
                    <v-avatar class="ma-0 pa-0" size="30">
                      <img v-if="item.profilePhoto" :src="item.profilePhoto" />
                      <img v-else :src="noImage" />
                    </v-avatar>
                    <span style="padding-left: 10px">
                      <span v-if="item.firstName">
                        {{ item.firstName + " " + item.lastName }}
                      </span>
                      <span v-else>{{ item.email }}</span>
                    </span>
                  </v-chip>
                </td>
              </tr>
            </table>
          </div>
          <v-divider></v-divider>
          <div
            class="container"
            v-if="filteredUsers.length"
            style="
              width: 100%;
              margin: 10px;
              font-family: Arial, Helvetica, sans-serif;
              font-size: 20px;
            "
          >
            <div
              class="row"
              style="justify-content: center; margin-right: 10px"
            >
              <div
                class="col-md-12 col-sm-12 col-lg-12"
                style="
                  background-color: var(--v-Neutral-base);
                  padding: 0 0 20px 0;
                "
              >
                <div class="row">
                  <div
                    class="col-12 col-md-6 col-sm-12 col-lg-6 avoidPageBreak"
                    v-for="(item, index) in filteredUsers"
                    :key="index"
                    style="padding: 7px"
                  >
                    <div
                      class="mx-auto avoidPageBreak"
                      style="padding: 15px 0 0 0; max-width: 100%"
                    >
                      <div
                        class="avoidPageBreak"
                        style="
                          height: 100%;
                          background-image: linear-gradient(
                            to top right,
                            rgb(255, 255, 255, 1.5),
                            rgba(255, 255, 255, 0.9)
                          );
                        "
                        src="CardBackground.jpg"
                      >
                        <div
                          class="row avoidPageBreak"
                          style="padding: 8px; align-items: flex-end !important"
                        >
                          <div
                            class="col-12 col-md-4 col-sm-12 col-lg-4"
                            style="
                              align-self: center !important;
                              padding-top: 0;
                              padding-bottom: 0;
                            "
                          >
                            <v-avatar
                              color="Neutral"
                              style="
                                margin-left: 0px;
                                margin-right: 0px;
                                height: 210px;
                                width: 172px;
                                max-width: 173px;
                                border-radius: 0;
                              "
                            >
                              <img
                                v-if="item.profilePhoto"
                                :src="item.profilePhoto"
                                style="height: 210px; width: 100%"
                              />
                              <img v-else src="@/assets/images/No-Photo.jpg" />
                            </v-avatar>
                          </div>
                          <div
                            class="col-12 col-md-8 col-sm-8 col-lg-8"
                            style="
                              padding-left: 0;
                              padding-right: 12px !important;
                              padding-bottom: 0;
                              padding-top: 0;
                              align-self: flex-start !important;
                              margin-bottom: 0;
                            "
                          >
                            <div
                              style="
                                border-radius: 0 !important;
                                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2),
                                  0 0 0 0 rgba(0, 0, 0, 0.14),
                                  0 0 0 0 rgba(0, 0, 0, 0.12) !important;
                                border-left: 1px solid #d9d9d9;
                                background-color: #fff;
                                display: flex;
                                width: 100%;
                                padding-bottom: 0;
                              "
                            >
                              <div style="padding: 8px 0 4px 0">
                                <div
                                  class="v-list-item"
                                  style="
                                    align-items: start;
                                    padding: 0px;
                                    min-height: 15px;
                                    padding-bottom: 4px;
                                  "
                                >
                                  <v-chip
                                    class="emailChip"
                                    style="
                                      height: auto;
                                      font-size: 12px;
                                      padding-left: 8px !important;
                                      background-color: transparent !important;
                                    "
                                  >
                                    <v-icon
                                      style="
                                        margin-left: 6px;
                                        margin-right: 6px;
                                        color: #006cad !important;
                                        margin-top: 4px;
                                      "
                                      small
                                    >
                                      mdi-email
                                    </v-icon>
                                    <strong
                                      style="
                                        white-space: normal;
                                        overflow-wrap: anywhere;
                                      "
                                    >
                                      {{ item.registered_email }}
                                    </strong>
                                  </v-chip>
                                </div>
                                <v-divider style="margin-top: 4px"></v-divider>
                                <div
                                  class="row"
                                  style="
                                    margin-left: 0;
                                    margin-right: 10px;
                                    padding-bottom: 10px;
                                  "
                                >
                                  <div
                                    class="col-12 col-sm-6 col-md-6 col-lg-6"
                                    style="padding-top: 5px; padding-bottom: 0"
                                  >
                                    <div
                                      class="v-list-item"
                                      style="
                                        margin-top: 5px;
                                        margin-bottom: 0;
                                        align-items: start;
                                        padding: 0px;
                                        min-height: 15px;
                                      "
                                    >
                                      <v-chip class="chip">
                                        <strong>
                                          {{
                                            $t("statistics.lblAttendanceRate")
                                          }}:
                                        </strong>
                                        {{
                                          Number(
                                            getAttendance(item.attendanceData)
                                          )
                                        }}%
                                      </v-chip>
                                    </div>
                                    <div
                                      class="v-list-item"
                                      style="
                                        align-items: start;
                                        padding: 0px;
                                        min-height: 15px;
                                      "
                                    >
                                      <v-chip class="chip">
                                        <strong
                                          style="padding-right: 4px !important"
                                          >{{
                                            $t("statistics.lblInvited")
                                          }}:</strong
                                        >
                                        {{ item.attendanceData.invited }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="v-list-item"
                                      style="
                                        align-items: start;
                                        padding: 0px;
                                        min-height: 15px;
                                      "
                                    >
                                      <v-chip class="chip">
                                        <strong
                                          style="padding-right: 4px !important"
                                        >
                                          {{
                                            $t("statistics.lblAttended")
                                          }}:</strong
                                        >
                                        {{ item.attendanceData.attended }}
                                      </v-chip>
                                    </div>

                                    <div
                                      class="v-list-item"
                                      style="
                                        align-items: start;
                                        padding: 0px;
                                        min-height: 15px;
                                      "
                                    >
                                      <v-chip class="chip">
                                        <strong
                                          style="padding-right: 4px !important"
                                        >
                                          {{
                                            $t("statistics.lblRemote")
                                          }}:</strong
                                        >
                                        {{ item.attendanceData.remote }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="v-list-item"
                                      style="
                                        align-items: start;
                                        padding: 0px;
                                        min-height: 15px;
                                      "
                                    >
                                      <v-chip class="chip">
                                        <strong
                                          style="padding-right: 4px !important"
                                        >
                                          {{
                                            $t("statistics.lblAbsent")
                                          }}:</strong
                                        >
                                        {{ item.attendanceData.absent }}
                                      </v-chip>
                                    </div>
                                  </div>
                                  <div
                                    class="col-12 col-sm-6 col-md-6 col-lg-6"
                                    style="
                                      padding-left: 0 !important;
                                      padding-top: 0px !important;
                                    "
                                  >
                                    <attendance-analysis-chart :item="item">
                                    </attendance-analysis-chart>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-lg-12"
                                    style="
                                      padding-bottom: 0px !important;
                                      padding-top: 0px !important;
                                    "
                                  >
                                    <v-divider
                                      style="marging-left: 16px"
                                    ></v-divider>
                                    <div
                                      class="v-list-item"
                                      style="
                                        margin-top: 0px;
                                        margin-bottom: 0;
                                        align-items: start;
                                        padding: 0px;
                                        min-height: 15px;
                                      "
                                    >
                                      <v-chip class="chip">
                                        <strong>
                                          {{
                                            $t("statistics.lblInWriting")
                                          }}:</strong
                                        >
                                        {{ item.attendanceData.in_writing }}
                                      </v-chip>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-12 col-md-12 col-sm-12 col-lg-12 avoidPageBreak"
                            style="padding-top: 0; padding-bottom: 0px"
                          >
                            <div
                              class="primary-gradient v-list-item"
                              style="
                                align-items: center;
                                color: #fff;
                                font-weight: 700 !important;
                                padding: 0 16px;
                              "
                            >
                              <div
                                class="v-list-item__content"
                                style="
                                  padding-top: 5px;
                                  padding-bottom: 5px;
                                  min-height: 50px;
                                  vertical-align: top;
                                "
                              >
                                <div class="subtitle-2">
                                  <span v-if="item.firstName">{{
                                    item.firstName + " " + item.lastName
                                  }}</span>
                                  <span v-else>{{
                                    item.registered_email
                                  }}</span>
                                </div>
                                <div
                                  class="caption v-list-item__subtitle"
                                  v-show="item.title"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <span v-bind="attrs" v-on="on">{{
                                        item.title
                                      }}</span>
                                    </template>
                                    <span>{{ item.title }}</span>
                                  </v-tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import noImage from "@/assets/images/NoPhotoIcon.png";
import { mapGetters, mapState } from "vuex";
import Vue from "vue";
import VueHtml2pdf from "vue-html2pdf";
import AttendanceAnalysisChart from "./AttendanceAnalysisChart.vue";
import { formatDate } from "@/utils/util";
Vue.use(VueHtml2pdf);
export default {
  name: "AttendancePDF",
  components: { AttendanceAnalysisChart },
  data() {
    return {
      noImage,
      render: 0,
      meetingTypeObj: {},
      filteredUsers: [],
      sessionStatisticsInputs: null,
    };
  },
  props: {
    loading: {
      type: Boolean,
    },
  },
  watch: {
    async statisticsData(val) {
      this.filteredUsers = [];

      if (Object.keys(val).length) {
        await this.getUsers(val);
      }
    },
  },
  created() {
    let sessionFilterInputs = sessionStorage.getItem("statisticsFilterInputs");
    this.sessionStatisticsInputs = JSON.parse(sessionFilterInputs);
  },
  async mounted() {
    this.$emit("load", true);
    this.meetingTypesList.forEach((meetType) => {
        if (this.sessionStatisticsInputs?.meeting_type_id === meetType.id) {
          this.meetingTypeObj = meetType;
        }
      });
    if (Object.keys(this.statisticsData).length) {
      await this.getUsers(this.statisticsData); // To set Filtered results
    }
    await this.generatePDF();
  },
  methods: {
    formatDate,
    getAttendance(data) {
      let attended = Number(data.attended);
      let attendance;
      if (data.invited > 0) {
        attendance = (Number(attended) / Number(data.invited)) * 100;
      } else {
        attendance = 0;
      }
      return attendance.toFixed(0);
    },
    onProgress(e) {},
    async generatePDF() {
      this.$emit("load", true);
      await this.exportToPDF();
    },
    async exportToPDF() {
      let obj = this;
      setTimeout(async() => {
        await obj.$refs?.html2Pdf?.generatePdf();
      }, 3000);
    },
    hasDownloaded(e) {
      this.$emit("load", false);
      setTimeout(async () => {
        this.$emit("pdfRender", false);
      }, 2000);
    },
    getUsers(res) {
      for (const key in res) {
        if (res.hasOwnProperty(key)) {
          this.userList.forEach((user) => {
            const element = res[user.id];
            if (user.id === key) {
              user.attendanceData = element;
              this.filteredUsers.push(user);
            }
          });
        }
      }
    },
  },
  computed: {
    ...gettersMap(),
    ...mapState({
      statisticsData: (state) => state.admin.statisticsData,
      userList: (state) => state.people.userList,
    }),
    pdfOptions() {
      return {
        margin: [5, 0, 6, 0],
        filename: this.slugify,
        image: {
            type: 'jpeg', 
            quality: 1
        },
        enableLinks: false,
        html2canvas: {
            scale: 2,
            useCORS: true
        },
        jsPDF: {
            format: 'a4',
            orientation: 'landscape'
        }
      }
    },
    meetingTypesList() {
      if (this.meetingTypes && this.meetingTypes.length > 0) {
        return this.meetingTypes.filter((item) =>
          this.$security.checkMeetingTypeAccess(item.id, "CreateMeeting")
        );
      }
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    slugify() {
      if (this.sessionStatisticsInputs) {
        let sDate = this.formatDate(
          new Date(this.sessionStatisticsInputs?.start_date),
          this.dateFormat
        );
        let eDate = this.formatDate(
          new Date(this.sessionStatisticsInputs?.end_date),
          this.dateFormat
        );
        return `${this.$t(
          "statistics.hAttendanceAnalysis"
        )} From ${sDate} to ${eDate}`
          .trim()
          .replace(/[^\w\s-]/g, "")
          .replace(/[\s_-]+/g, "-")
          .replace(/^-+|-+$/g, "");
      }
    },
  },
};
function gettersMap() {
  return mapGetters({
    meetingTypes: "tenant/agendaMeetingTypes",
  });
}
</script>

<style scoped>
.Neutral {
  background-color: var(--v-Neutral-lighten1) !important;
  border-color: var(--v-Neutral-lighten1) !important;
}
.primary-gradient {
  color: #fff !important;
  background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.08)), #006cad !important;
  font-weight: 700 !important;
}
.v-list-item {
  align-items: center;
  display: flex;
  flex: 1 1 100%;
  letter-spacing: normal;
  outline: none;
  margin-top: -5px;
  margin-bottom: 0;
  position: relative;
  text-decoration: none;
}
.chip {
  font-size: 13px;
  padding-left: 8px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  background-color: transparent !important;
}
.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}
.avoidPageBreak {
  break-inside: avoid;
}
.vue-html2pdf /deep/ .layout-container {
  display: none !important;
}
.v-list-item__content {
  align-items: center;
  align-self: center;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1;
  overflow: hidden;
  padding: 12px 0;
}
.v-list-item-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.subtitle-2 {
  font-size: 0.875rem !important;
  font-weight: 500;
  letter-spacing: 0.0071428571em !important;
  line-height: 1.375rem;
  font-family: Roboto, sans-serif !important;
}
</style>